/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_OverlineInputs */

const en_mk_sol_overline = /** @type {(inputs: Mk_Sol_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An illustrated example`)
};

const id_mk_sol_overline = /** @type {(inputs: Mk_Sol_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contoh penerapan`)
};

/**
* | output |
* | --- |
* | "An illustrated example" |
*
* @param {Mk_Sol_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_overline = /** @type {((inputs?: Mk_Sol_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_overline(inputs)
	return en_mk_sol_overline(inputs)
});